'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp; // import Autosuggest from 'react-autosuggest'

// import Helmet from 'react-helmet'

// import Modal from 'react-modal'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactSlidedown = require('react-slidedown');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./FundTobaccoInvestments.css');
// const MaxPerPage = 5
var FirstPage = 5;
var AllPage = 1000000;

function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}

function filterHoldings(fHoldingsMap, holdings, filterFn) {
  return (0, _lodash.chain)(holdings).filter(filterFn).sortBy(function (o) {
    return fHoldingsMap[o.id].market_value * -1;
  })
  // .take(10)
  .value();
}

var FundTobaccoInvestments = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  // need otherwise cient navigate is blocked until the page is loaded
  deferred: true,
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundTobaccoInvestments, _Component);

  function FundTobaccoInvestments(props) {
    (0, _classCallCheck3.default)(this, FundTobaccoInvestments);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundTobaccoInvestments.__proto__ || (0, _getPrototypeOf2.default)(FundTobaccoInvestments)).call(this, props));

    _this.handleScroll = function () {
      if (!_this.props.result) {
        return;
      }
    };

    _this.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this.clickViewMore = function () {
      _this.setState({ viewMore: !_this.state.viewMore });
    };

    _this.increment = function (incState) {
      return function () {
        var newState = {};
        newState[incState] = _this.state[incState] + 1;
        _this.setState(newState);
      };
    };

    _this.holdingsCount = function (count) {
      if (count > 0) {
        return _format2.default.number(count) + ' HOLDINGS';
      }
      return '';
    };

    _this.hasEngagementStatement = function (name, sri) {
      var engagementFamily = _config2.default.engagementFunds.find(function (family) {
        return family.name === name;
      });

      // we're done if it's not an engagement family
      if (!engagementFamily) {
        return null;
      }
      // otherwise, check for SRI
      // only show the statement if family is engager, has statement,
      // and fund is SRI
      return engagementFamily.statement && _convert2.default.boolean(sri);
    };

    _this.renderGradeBox = function (name, grade_tobacco, sri) {
      // values
      var hasEngagementBadge = _convert2.default.float(grade_tobacco) === 1.5;
      var letterGrade = _format2.default.score(grade_tobacco);
      var sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade;
      var descriptions = {
        A: 'No holdings flagged for our tobacco screens. Assigned a grade of A.',
        E: 'Err-e',
        B: 'Fund is invested in tobacco-promoting entertainment companies, but no holdings flagged for our tobacco producer screen. Assigned a grade of B.',
        C: 'Fund is invested in tobacco producers, below the threshold of 0.5%. Assigned a grade of C.',
        D: 'Fund is invested in tobacco producers, above the threshold of 0.5% and below 1.2%. Assigned a grade of D.',
        F: 'Fund is invested in tobacco producers, above the threshold of 1.2%. Assigned a grade of F.',
        NA: 'Error'
      };
      var description = descriptions[sfGrade];

      return _react2.default.createElement(
        'div',
        { styleName: 'grade-snapshot' },
        /* display engagement grade or letter grade */
        _convert2.default.boolean(hasEngagementBadge) ? _react2.default.createElement(
          'div',
          { styleName: 'grade-intro' },
          _react2.default.createElement(
            'strong',
            null,
            'Tobacco engagement grade:'
          ),
          ' This special grade is only given to funds offered by an asset manager with a proven track record of engaging the companies it invests in to push for better corporate behavior.',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              to: _config2.default.routes.faq + '#5',
              title: 'FAQ: What are socially responsible funds?'
            },
            'Learn more about fund engagement and sustainable investing',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        ) : _react2.default.createElement(
          'div',
          { styleName: 'grade-intro' },
          _react2.default.createElement(
            'strong',
            null,
            'Tobacco grade:'
          ),
          ' ',
          description,
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _components.Link,
            {
              xstrong: true,
              to: _config2.default.routes.faq + '#4',
              title: 'FAQ: Where does the "Tobacco Grade" come from?'
            },
            'How we track tobacco investments',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'grade-wrapper' },
          _react2.default.createElement(_components.Grade, { grade: grade_tobacco, large: true })
        )
      );
    };

    _this.renderUssifBadge = function () {
      // images
      var ussifLogo = require('../../../static/images/ussif-logo.png');

      // values
      var usfLbl = 'Member of The Forum for Sustainable and Responsible ' + 'Investment icon';
      var usfLbl2 = 'US-SIF: Forum for Sustainable and Responsible ' + 'Investment';

      return _react2.default.createElement(
        'div',
        { styleName: 'ussif-badge-inner' },
        _react2.default.createElement(
          'div',
          { styleName: 'ussif-img-wrap' },
          _react2.default.createElement('img', {
            styleName: 'ussif-badge-img',
            src: ussifLogo,
            alt: usfLbl
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'ussif-badge-info' },
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-info-title' },
            'Member of the Forum for Sustainable and Responsible Investment'
          ),
          _react2.default.createElement(
            'div',
            null,
            'This asset manager is a member of the Forum for Sustainable and Responsible Investment, a group advancing sustainable, responsible, and impact investing.'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-info-subtitle' },
            'Learn more: ',
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.ussif,
                xstrong: true,
                title: usfLbl2
              },
              'Forum for Sustainable and Responsible Investment'
            )
          )
        )
      );
    };

    _this.renderUssifTobaccoPolicy = function (policy) {
      // images
      var tobaccoPolicyExclusionIcon = require('../../../static/images/tobacco-policy-exclusion.svg');
      var tobaccoPolicyResctrictedIcon = require('../../../static/images/tobacco-policy-restricted.svg');
      var tobaccoPolicyNoneIcon = require('../../../static/images/tobacco-policy-none.svg');
      // values
      var asOfDate = 'August 30, 2020';
      var usfLbl = 'US-SIF: Forum for Sustainable and Responsible Investment';

      // let policy

      return _react2.default.createElement(
        'div',
        { styleName: 'ussif-policy-container' },
        policy === 'X' ? _react2.default.createElement(
          'div',
          { styleName: 'ussif-policy-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-img-wrap' },
            _react2.default.createElement('img', {
              styleName: 'ussif-policy-img',
              src: tobaccoPolicyExclusionIcon,
              alt: 'Tobacco Exclusion Policy'
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-policy-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-title' },
              'Tobacco Exclusion Policy'
            ),
            _react2.default.createElement(
              'div',
              null,
              'This fund has a policy to exclude investments in companies involved in the production, licensing, and/or retailing of tobacco products, or in the manufacturing of products necessary for production of tobacco products.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'As of ',
              asOfDate
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'Source: ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.ussifChart,
                  xstrong: true,
                  title: usfLbl
                },
                'US-SIF Sustainable and Responsible Mutual Fund Chart'
              )
            )
          )
        ) : null,
        policy === 'R' ? _react2.default.createElement(
          'div',
          { styleName: 'ussif-policy-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-img-wrap' },
            _react2.default.createElement('img', {
              styleName: 'ussif-policy-img',
              src: tobaccoPolicyResctrictedIcon,
              alt: 'Tobacco Restriction Policy'
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-policy-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-title' },
              'Tobacco Restriction Policy'
            ),
            _react2.default.createElement(
              'div',
              null,
              'This fund has a policy to restrict investments in companies involved in the production, licensing, and/or retailing of tobacco products, or in the manufacturing of products necessary for production of tobacco products.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'As of ',
              asOfDate
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'Source: ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.ussifChart,
                  xstrong: true,
                  title: usfLbl
                },
                'US-SIF Sustainable and Responsible Mutual Fund Chart'
              )
            )
          )
        ) : null,
        policy === '--' ? _react2.default.createElement(
          'div',
          { styleName: 'ussif-policy-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-img-wrap' },
            _react2.default.createElement('img', {
              styleName: 'ussif-policy-img',
              src: tobaccoPolicyNoneIcon,
              alt: 'No Tobacco Exclusion or Restriction Policy'
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ussif-policy-info' },
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-title-disabled' },
              'No Tobacco Exclusion or Restriction Policy'
            ),
            _react2.default.createElement(
              'div',
              null,
              'This fund is a member of US-SIF, but does not have an active policy to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of tobacco products, or in the manufacturing of products necessary for production of tobacco products.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'As of ',
              asOfDate
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'ussif-info-subtitle' },
              'Source: ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.ussifChart,
                  xstrong: true,
                  title: usfLbl
                },
                'US-SIF Sustainable and Responsible Mutual Fund Chart'
              )
            )
          )
        ) : null
      );
    };

    _this.renderEngagementStatement = function (name) {
      // filter engagement families from config to see if this family is
      // eligible for a statement box
      var engagementFamily = _config2.default.engagementFunds.find(function (family) {
        return family.name === name;
      });

      // exit if it's not an engagement family
      if (!engagementFamily) {
        return null;
      }
      // encode URI since family names have special chars
      var safeName = encodeURIComponent(engagementFamily.name);

      return _react2.default.createElement(
        'div',
        { styleName: 'engagement-statement-container' },
        _react2.default.createElement(
          'div',
          { styleName: 'engagement-statement-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'engagement-statement' },
            _react2.default.createElement(
              'div',
              { styleName: 'engagement-statement-title' },
              'This fund family submitted a statement describing their engagement efforts:'
            ),
            _react2.default.createElement(
              'blockquote',
              { styleName: 'engagement-statement-quote' },
              engagementFamily.statement
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'engagement-statement-link' },
              _react2.default.createElement(
                _components.Link,
                {
                  xstrong: true,
                  to: _config2.default.routes.families + '?q=' + safeName,
                  title: engagementFamily.name
                },
                'See more funds from this fund family'
              )
            )
          )
        )
      );
    };

    _this.renderHoldings = function (shareClass, fHoldingsMap, holdings, page) {
      // no holdings found
      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'holdings-none' },
          'NONE'
        );
      }

      // values
      var takeCount = page > 1 ? AllPage : FirstPage;

      return (0, _lodash.chain)(holdings).take(takeCount).map(function (holding, idx) {
        return _react2.default.createElement(
          'li',
          { key: idx, styleName: 'holding' },
          _react2.default.createElement(
            'div',
            { styleName: 'holding-name' },
            idx + 1,
            '. ',
            holding.security_name
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            _format2.default.perc(fHoldingsMap[holding.id].long_weight),
            ' of portfolio'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-invested' },
            _format2.default.money(fHoldingsMap[holding.id].market_value, true, shareClass.currency, true),
            ' invested'
          )
        );
      }).value();
    };

    _this.renderCompanies = function (shareClass, fHoldingsMap, type, label, count, holdings, page) {
      // images
      var iconLabel = { 'to': 'cigarette', 'tm': 'cinema' }[type];
      var tXIcon = require('../../../static/images/icon-' + iconLabel + '.svg');

      // values
      var _count = _convert2.default.int(count);
      var hasMoreButton = page === 1 && _count > FirstPage ? _react2.default.createElement(
        'div',
        {
          styleName: 'detail-more-' + type,
          onClick: _this.increment(type + 'Page')
        },
        'See all',
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-down' })
      ) : null;

      // no holdings found
      if (_count === 0) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, styleName: 'detail-holdings-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-wrapper-empty' },
            _react2.default.createElement('img', {
              styleName: 'detail-icon-empty',
              src: tXIcon,
              alt: label + ' icon'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-empty' },
              label
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-holdings-empty' },
              '0 holdings'
            )
          )
        );
      }

      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { xs: 12, styleName: 'detail-holdings-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-' + type },
          _react2.default.createElement('img', {
            styleName: 'to-icon',
            src: tXIcon,
            alt: label + ' icon'
          }),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-title-holdings' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title-' + type },
              label
            ),
            _react2.default.createElement(
              'div',
              {
                styleName: 'visible-sm visible-md visible-lg detail-holdings-count-' + type
              },
              _this.holdingsCount(_count)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs mobile-holdings-label' },
            _count,
            ' holdings'
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _react2.default.createElement(
              'ul',
              { styleName: 'detail-holdings' },
              _this.renderHoldings(shareClass, fHoldingsMap, holdings, page)
            )
          )
        ),
        hasMoreButton
      );
    };

    _this.renderStats = function (shareClass) {
      function renderCol(type, entries, hasLine) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 6, styleName: 'col-' + type + '-wrapper' },
          entries.map(function (entry, idx) {
            return _react2.default.createElement(
              'div',
              { key: idx, styleName: 'col-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'col-' + type },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-label' },
                  entry.name
                ),
                entry.link ? _react2.default.createElement(
                  _components.Link,
                  { to: entry.link, title: entry.name },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-value-link' },
                    entry.value
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'stats-value' },
                  entry.value
                )
              ),
              hasLine && idx !== entries.length - 1 ? _react2.default.createElement('div', { styleName: 'col-line' }) : null
            );
          })
        );
      }
      // values
      var tobacco_overall_rating = shareClass.tobacco_overall_rating,
          grade_tobacco = shareClass.grade_tobacco;
      // encode URI since family names have special chars

      var safeFam = encodeURIComponent(shareClass.fund_family_name);

      return _react2.default.createElement(
        'div',
        { styleName: 'stats' },
        _react2.default.createElement(
          'div',
          { styleName: 'stats-inner' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'stats-header' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-title' },
                'Mutual fund profile'
              )
            ),
            grade_tobacco ? _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-score-label-score' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-score-label' },
                  'Tobacco grade'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-score-wrapper' },
                  _react2.default.createElement(_components.Grade, { grade: grade_tobacco })
                )
              )
            ) : null
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{
              name: 'Shareclass ticker',
              value: shareClass.ticker
            }], false),
            renderCol('right', [{
              name: 'Data as of',
              value: (0, _moment2.default)(shareClass.date.slice(0, 10)).format('D MMM YYYY')
            }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{
              name: 'Shareclass name',
              value: shareClass.name
            }], false),
            renderCol('right', [{
              name: '% of Fund Assets Screened',
              value: _format2.default.perc(shareClass.percent_rated)
            }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{
              name: 'Shareclass type',
              value: _format2.default.legalType(shareClass.legal_type)
            }], false),
            renderCol('right', [{
              name: 'Fund Net Assets',
              value: _format2.default.money(shareClass.fund_net_assets, true, shareClass.currency)
            }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{
              name: 'Fund family',
              link: _config2.default.routes.families + '?q=' + safeFam,
              value: shareClass.fund_family_name
            }], false),
            renderCol('right', [{
              name: 'Fund Category',
              value: shareClass.morningstar_category_name
            }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{
              name: 'Domicile country',
              value: _format2.default.market(shareClass.market)
            }], false),
            renderCol('right', [{
              name: 'Portfolio Currency',
              value: _format2.default.currencyCode(shareClass.currency)
            }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{
              name: 'Non-diversification risk',
              value: _format2.default.boolean(shareClass.non_diversified_fund)
            }], false),
            renderCol('right', [{
              name: 'Social responsible fund',
              value: _format2.default.boolean(shareClass.socially_responsible_fund || "0")
            }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 6, styleName: 'col-left-wrapper' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 6, styleName: 'col-right-wrapper' },
              _react2.default.createElement(
                'div',
                { styleName: 'col-label-value' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'col-right' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-label' },
                    'Tobacco star grade (legacy)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-value' },
                    _react2.default.createElement(_components.LegacyTobaccoGrade, {
                      legacy: true,
                      score: shareClass.tobacco_overall_rating
                    })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Tobacco totals'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total flagged holdings for tobacco and tobacco-promoting entertainment companies'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.t_all_count)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % of fund assets flagged for tobacco and tobacco-promoting entertainment companies'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.t_all_weight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total fund assets invested in tobacco and tobacco-promoting entertainment companies'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.t_all_asset, true, shareClass.currency, false)
              )
            )
          )
        )
      );
    };

    _this.renderTakeAction = function (shareClass) {
      function renderAction(info, button, link, log) {
        return _react2.default.createElement(
          'div',
          { styleName: 'take-action-action' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-info' },
            info
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-button-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: link,
                log: log,
                title: button
              },
              _react2.default.createElement(
                'div',
                { styleName: 'take-action-button' },
                button,
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        );
      }

      var ticker = shareClass.ticker || 'N';
      var fffUrl1 = _config2.default.links.fffFund + '/' + shareClass.fund_id + '/';
      var fffUrl2 = shareClass.investment_vehicle_id + '/' + ticker;
      var fffUrl = '' + fffUrl1 + fffUrl2;

      return _react2.default.createElement(
        'div',
        { styleName: 'take-action-wrap' },
        _react2.default.createElement('div', {
          styleName: 'take-action-anchor',
          id: 'take-action'
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'take-action' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'take-action-header' },
              'Take Action'
            ),
            _react2.default.createElement('div', { styleName: 'take-action-line' }),
            renderAction('Take action and sign our letter to the media companies', 'Speak out', _config2.default.links.speakout),
            renderAction('Find mutual funds that steer clear of tobacco', 'Find tobacco free funds', _config2.default.routes.clean),
            renderAction('Talk to your retirement plan manager about tobacco-free ' + 'investment options', 'Use our toolkit', _config2.default.routes.toolkit, _analytics2.default.eventToToolkit()),
            renderAction('Use FossilFreeFunds.org to see the climate impact of ' + 'this fund', 'See climate impact', fffUrl, _analytics2.default.eventToFFF(shareClass.fund_id, shareClass.investment_vehicle_id))
          )
        )
      );
    };

    _this.renderMoreButton = function (portfolioDate) {
      var viewMore = _this.state.viewMore;

      var label = viewMore ? 'View less' : 'View full fund profile';
      var icon = viewMore ? 'fa-angle-up' : 'fa-angle-down';
      return _react2.default.createElement(
        'div',
        { styleName: 'view-more-wrapper' },
        _react2.default.createElement(
          'button',
          {
            styleName: 'view-more',
            title: label,
            onClick: _this.clickViewMore
          },
          label,
          _react2.default.createElement(_components.LinkIcon, { faclass: icon })
        )
      );
    };

    _this.renderMore = function (shareClass, showDataAs) {
      return _react2.default.createElement(
        'div',
        { styleName: 'more-stats' },
        _this.renderMoreButton(shareClass.date),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          _this.state.viewMore ? _this.renderStats(shareClass) : null
        )
      );
    };

    _this.state = {
      // openModal: false,
      toPage: 1,
      tmPage: 1,
      viewMore: false
    };
    return _this;
  }

  (0, _createClass3.default)(FundTobaccoInvestments, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
    }
    // need this solution since asyncConnect and anchor links does not play nice

  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      function getPerc(asset, totalAsset) {
        asset = _convert2.default.int(asset);
        totalAsset = _convert2.default.int(totalAsset);
        if (totalAsset === 0) {
          return 0;
        }
        return _convert2.default.float((asset / totalAsset * 100).toFixed(2));
      }

      // images
      var toIcon = require('../../../static/images/icon-cigarette.svg');
      var tmIcon = require('../../../static/images/icon-cinema.svg');
      var magnifyIcon = require('../../../static/images/icon-magnifying-glass-green.svg');

      // objects and values
      var _props$result = this.props.result,
          shareClass = _props$result.shareClass,
          fund = _props$result.fund;
      var fund_id = shareClass.fund_id,
          investment_vehicle_id = shareClass.investment_vehicle_id;

      var ticker = shareClass.ticker || 'N';
      var toPerc = getPerc(shareClass.to_asset, shareClass.fund_net_assets);
      var tmPerc = getPerc(shareClass.tm_asset, shareClass.fund_net_assets);

      // map and filter holdings
      var fHoldingsMap = mapFundHoldings(fund.fundholdings);
      var toHoldings = filterHoldings(fHoldingsMap, fund.holdings, function (h) {
        return h.is_to;
      });
      var tmHoldings = filterHoldings(fHoldingsMap, fund.holdings, function (h) {
        return h.is_tm;
      });

      // present url
      var url1 = '' + _config2.default.domain + _config2.default.routes.fund + '/';
      var url2 = _format2.default.sanitize(fund.fund_legal_name) + '/' + ticker + '/';
      var url3 = 'tobacco-profile/' + fund_id + '/' + investment_vehicle_id;
      var url = '' + url1 + url2 + url3;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(shareClass.fund_legal_name, url),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            'div',
            { styleName: 'snapshot-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'snapshot' },
              _react2.default.createElement(_components.Chart, {
                renderBox: (0, _reactCssModules2.default)(this.renderGradeBox, Styles),
                currency: shareClass.currency,
                invested: _convert2.default.float(shareClass.t_all_asset),
                tmPerc: tmPerc,
                toPerc: toPerc,
                fundFamilyName: fund.fund_family_name,
                tobaccoOverallRating: fund.grade_tobacco,
                sri: _convert2.default.boolean(fund.socially_responsible_fund)
              }),
              _react2.default.createElement(_components.FlaggedFund, {
                count: _convert2.default.int(shareClass.t_all_count),
                weight: _convert2.default.float(shareClass.t_all_weight)
              }),
              /* IF USSIF: RENDER BADGES */
              _convert2.default.float(fund.ussif) === 1.5 ? _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'ussif-wrapper' },
                    this.renderUssifBadge(),
                    this.renderUssifTobaccoPolicy(fund.tff_ussif_policy)
                  )
                )
              ) : null,
              /* IF HAS ENGAGEMENT STATEMENT: RENDER */
              this.hasEngagementStatement(shareClass.fund_family_name, shareClass.socially_responsible_fund) ? _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12 },
                  this.renderEngagementStatement(shareClass.fund_family_name)
                )
              ) : null,
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 6, styleName: 'detail-tobacco-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-to' },
                    _react2.default.createElement('img', { styleName: 'detail-icon', src: toIcon,
                      alt: 'Tobacco companies' }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-title' },
                      'Tobacco companies'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-stat' },
                      _format2.default.number(shareClass.to_count),
                      ' holdings'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-stat' },
                      _format2.default.perc(shareClass.to_weight),
                      ' of assets'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-stat' },
                      _format2.default.money(shareClass.to_asset, true, shareClass.currency),
                      ' invested'
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 6, styleName: 'detail-movies-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-tm' },
                    _react2.default.createElement('img', { styleName: 'detail-icon', src: tmIcon,
                      alt: 'Tobacco-promoting entertainment companies' }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-title' },
                      'Tobacco-promoting entertainment companies'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-stat' },
                      _format2.default.number(shareClass.tm_count),
                      ' holdings'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-stat' },
                      _format2.default.perc(shareClass.tm_weight),
                      ' of assets'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'detail-stat' },
                      _format2.default.money(shareClass.tm_asset, true, shareClass.currency),
                      ' invested'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'holdings-count-intro' },
                  'Why entertainment companies?'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'holdings-count-intro-info' },
                  '\u201CR\u201D-rating future movies with smoking will prevent one million tobacco deaths in this generation of U.S. kids. Hollywood studios and their parent companies, the nation\u2019s best-known entertainment companies, are well aware of the public health risk, ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.faq + '#2',
                      title: 'FAQ: Why entertainment companies?',
                      strong: true
                    },
                    'but continue to intentionally expose millions of kids.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'holdings-count-title' },
                  'Tell Hollywood to rate smoking \u201CR\u201D'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'holdings-count-info' },
                  'Join our call to eliminate smoking from youth-rated movies'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.speakout,
                    bigbutton: true,
                    title: 'Take action: Tell Hollywood to take smoking out of ' + 'kid-rated movies!'
                  },
                  'Take action',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-outro' },
                'This fund contains'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-count-stat' },
                _format2.default.number(shareClass.t_all_count),
                ' investments in tobacco producers and tobacco-promoting entertainment companies'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                { styleName: 'details' },
                this.renderCompanies(shareClass, fHoldingsMap, 'to', 'Tobacco companies', shareClass.to_count, toHoldings, this.state.toPage),
                this.renderCompanies(shareClass, fHoldingsMap, 'tm', 'Tobacco-promoting entertainment companies', shareClass.tm_count, tmHoldings, this.state.tmPage),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'why-title' },
                    'Are entertainment companies rated the same as tobacco companies?'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'why-info' },
                    'No - tobacco companies bear greater responsibility to the tobacco epidemic, and ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.faq + '#4',
                        title: 'FAQ: Where does the "Tobacco Grade" come from?',
                        strong: true
                      },
                      'our grading methodology reflects this'
                    ),
                    '. However, the scientific consensus is that tobacco depictions in movies cause kids to begin smoking. Public health impacts can damage a company\u2019s reputation and brand value, decreasing long-term shareholder value. Asset managers should be engaging entertainment companies by ',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.speakout,
                        title: 'Take action: Tell Hollywood to take smoking out ' + 'of kid-rated movies!',
                        strong: true
                      },
                      'signing investor letters'
                    ),
                    ', supporting shareholder resolutions, or otherwise pressing entertainment companies to remove smoking from youth-rated movies.'
                  )
                )
              )
            )
          ),
          this.renderMore(shareClass),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.InlineSignup, null)
          ),
          _react2.default.createElement(_components.IyvScorecard, { fund: fund, shareClass: shareClass }),
          _react2.default.createElement(_components.Returns, { fund: fund, shareClass: shareClass, url: url }),
          this.renderTakeAction(shareClass),
          _react2.default.createElement(
            'div',
            { styleName: 'banner' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-inner' },
              _react2.default.createElement(_components.AboutBanner, null)
            )
          )
        )
      );
    }
  }]);
  return FundTobaccoInvestments;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundTobaccoInvestments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundTobaccoInvestments/FundTobaccoInvestments.js
// module id = 1291
// module chunks = 0